import { useState } from 'react';
import { ApiError, login, requestLoginCode } from './api';

/**
 * The ordinary email-code login, not an admin-specific one.
 *
 * There is deliberately no separate admin credential: the server decides
 * admin from the allowlist, so a second password to lose would add a secret
 * without adding a boundary.
 */
export function Login({ onSignedIn }: { onSignedIn: () => void }) {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function run(work: () => Promise<void>) {
    setBusy(true);
    setError(null);
    try {
      await work();
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : String(caught));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="wrap login">
      <h1>eeyoo fleet</h1>
      {error && <p className="error">{error}</p>}
      {sent && (
        <p className="notice">
          Code sent. On the acceptance stack it is written to the server log:
          <code> docker compose --env-file .env.acc logs eeyoo-server | grep 'LOGIN CODE'</code>
        </p>
      )}

      <label>
        Email
        <input
          type="email"
          value={email}
          autoComplete="username"
          onChange={(event) => setEmail(event.target.value)}
        />
      </label>

      {!sent ? (
        <button
          disabled={busy || email.trim() === ''}
          onClick={() => run(async () => {
            await requestLoginCode(email.trim());
            setSent(true);
          })}
        >
          Send code
        </button>
      ) : (
        <>
          <label>
            Code
            <input
              value={code}
              inputMode="numeric"
              autoComplete="one-time-code"
              onChange={(event) => setCode(event.target.value)}
            />
          </label>
          <button
            disabled={busy || code.trim() === ''}
            onClick={() => run(async () => {
              await login(email.trim(), code.trim());
              onSignedIn();
            })}
          >
            Sign in
          </button>{' '}
          <button disabled={busy} onClick={() => setSent(false)}>Back</button>
        </>
      )}
    </div>
  );
}
